export default "__VITE_ASSET__dd80b263__"